import commonTranslations from 'app/locales/locale-en';

const localeTexts = {
    ...commonTranslations,

    detailsTableTitle: 'Kit Contents',

    msk: 'Moscow',
    mskOutside: 'Outside of MKAD',
    spb: 'Saint-Petersburg',
    spbOutside: 'Outside of KAD',

    dessert: 'Desserts',
    set: 'Kits',
    main: 'Mains',
    appetizer: 'Salads',
    niceStuff: 'Nice to add',

    detailsWeightTitle: 'Ready product',
    detailsCookTitle: 'Cooking',

    orderTitle: 'Order',
    orderOfferText: 'Pressing "Order", you agree with',
    orderOfferLink: 'Terms and Conditions',

    addressPlaceholder: 'Street, house number',
    flatPlaceholder: 'Apartment',
    entrancePlaceholder: 'Entrance',
    checkoutButton: 'Pay',

    checkoutDeliveryDateTitle: 'Delivery date',
    checkoutDeliveryTimeTitle: 'Delivery time',
    checkoutDeliveryDateDelimiter: 'New menu starting this delivery date',
    checkoutDeliveryDateInfoTimeChaned: 'Delivery time has changed!',
    checkoutDeliveryDateInfoDisabled: 'Please insert address in the field above to choose available delivery date',
    checkoutDeliveryDateInfoDeliveryZone: 'Other time slots are availble for the weekend',
    checkoutDeliveryDateInfoSelectInterval: 'Please pick available delivery time slot',
    checkoutDeliveryDateInfoIntervalChanged: 'Delivery time slots for outside MKAD deliveries have changed',
    checkoutDeliveryTimeInfoOneInterval: 'Only one delivery time slot available',

    checkoutErrorEmptyPhone: 'Please type in phone number',
    checkoutErrorDeliveryZone: 'Sorry, delivery is available only in Moscow and areas within 30 km outside MKAD',
    checkoutErrorEmptyAddress: 'Please type in address',
    checkoutErrorWrongAddress: 'Address is incorrect',
    checkoutErrorEmptyHouse: 'Please type in house number',

    basketTitle: 'Your order:',
    basketButtonTitle: 'Your cart:',
};

export default localeTexts;
